// extracted by mini-css-extract-plugin
module.exports = {"steps":"Steps_steps__2qV0H"};